import styled, { css } from 'styled-components';

export const IconViewContainer = styled.div`
${(props) => css`
  & + div {
    margin-left: 12px;
  };

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  width: 10rem;

  cursor: pointer;

  background-color: ${props.selected ? '#abcbfa' : '#fff'};
  border: ${props.selected ? '1px solid #1773ff' : '1px solid #666666'};
  
  background-color: ${props.deleted && '#cfcfcf'};
  border: ${props.deleted && '1px solid #868686'};
  
  border-radius: 8px;

  padding-top: 1rem;
  padding-bottom: 1rem;

  .selectButton {
    width: 20px;
    height: 20px;

    position: absolute;
    border: 1px solid #666666;

    top: 0;
    right: 0;

    margin-right: 4px;
    margin-top: 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 2px;

    border-radius: 2px;
  }

  .propertiesButton {
    width: 20px;
    height: 20px;
    position: absolute;
    
    cursor: pointer;

    top: 0;
    left: 0;

    margin-left: 4px;
    margin-top: 4px;
    padding: 2px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 0px solid #666666;
    border-radius: 2px;

    background-color: transparent;
  }
`}`;

export const ListViewContainer = styled.div`
  svg {
    margin-left: 6px;
    margin-right: 6px;
  };

  padding: 6px;

  .propertiesButton {
    display: flex;
    align-items: center;

    cursor: pointer;

    border: 0px solid #666666;
    border-radius: 2px;

    background-color: transparent;
  }

  ${(props) => css`
    background-color: ${props.selected ? '#abcbfa' : '#fff'};
    border: ${props.selected ? '1px solid #1773ff' : '1px solid #666666'};
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
  `}
`;

